import { ReactNode, Fragment, isValidElement, cloneElement } from 'react';

export const replaceTextInNode = (
  node: ReactNode,
  searchText: string,
  replaceText: string,
): ReactNode => {
  // If it's a string → replace directly
  if (typeof node === 'string') {
    return node.replaceAll(searchText, replaceText);
  }

  // If it's an array → process each item
  if (Array.isArray(node)) {
    return node.map((child, index) => (
      <Fragment key={index}>
        {replaceTextInNode(child, searchText, replaceText)}
      </Fragment>
    ));
  }

  // If it's a valid React element → clone with replaced children
  if (isValidElement<{ children?: React.ReactNode }>(node)) {
    return cloneElement(node, {
      children: replaceTextInNode(node.props.children, searchText, replaceText),
    });
  }

  // For everything else (null, boolean, etc.)
  return node;
};
